import React, { FC, useContext } from 'react';

// constants
import { FormulaType } from '../../../../constants/formulaType';

// context
import { EditorContext } from '../../../../context/EditorContext';

// models
import {
    MobilePushPreviewModel,
    SMSPreviewModel,
} from '../../../../models/editor.model';

import MobilePushMessagePreview from '../mobilePush/MobilePushMessagePreview';
// components
import SmsPreview from '../sms/SmsPreview';

interface CoverMessagePreviewProps {
    message: MobilePushPreviewModel | SMSPreviewModel | null;
    isSkeleton: boolean;
}

const CoverMessagePreview: FC<CoverMessagePreviewProps> = ({
    message,
    isSkeleton,
}) => {
    const {
        editorDetails: { formula },
    } = useContext(EditorContext);

    return formula?.message_type === FormulaType.sms ? (
        <SmsPreview
            id={message ? message.id : ''}
            formula_id={message ? message.formula_id : 0}
            isSkeleton={isSkeleton}
            content={{
                message: isSkeleton
                    ? 'Engage with a strong SMS message here.'
                    : (message as SMSPreviewModel).content.message,
            }}
        />
    ) : (
        <MobilePushMessagePreview
            id={message ? message.id : ''}
            formula_id={message ? message.formula_id : 0}
            isSkeleton={isSkeleton}
            content={{
                header: isSkeleton
                    ? 'Use a strong header'
                    : (message as MobilePushPreviewModel).content.header,
                body: isSkeleton
                    ? 'Engage with a strong headline Use this section to expand on your main message.'
                    : (message as MobilePushPreviewModel).content.body,
            }}
        />
    );
};

export default CoverMessagePreview;
